<template>
    <v-layout>
        <v-dialog v-model="dialog" eager max-width="600px" :persistent="loading">
            <template v-slot:activator="{ on }">
                <v-btn v-if="isNew" :class="{ 'rounded-btn': true, w100: $vuetify.breakpoint.xsOnly }" v-on="on" color="info">
                    <v-icon left>mdi-link</v-icon>
                    {{ $t('Добавить привязку к КСК') }}
                </v-btn>
                <v-btn v-else icon v-on="on" :title="$t('Редактирование привязки')">
                    <v-icon>edit</v-icon>
                </v-btn>
            </template>

            <LabeledCard :label="isNew ? $t('Новая привязка дома к КСК') : $t('Редактирование привязки дома к КСК')">
                <v-container class="pt-5" fluid>
                    <v-form ref="kskBindingForm" @submit.prevent="submitForm" class="pb-2">
                        <SelectKSKDialog v-model="selectedKSK">
                            <v-text-field
                                class="pointer"
                                dense
                                :label="$t('КСК дома')"
                                outlined
                                readonly
                                v-model="selectedKSK.isas_ksk_name"
                                :rules="lazyRules"
                            ></v-text-field>
                        </SelectKSKDialog>
                        <AddressSelector v-model="selectedHouse">
                            <v-text-field
                                class="pointer"
                                dense
                                :label="$t('Адрес дома')"
                                outlined
                                readonly
                                v-model="selectedHouse.address_full_name"
                                :rules="lazyRules"
                            ></v-text-field>
                        </AddressSelector>
                        <DatePicker
                            outlined
                            dense
                            class="pointer"
                            label="Дата начала привязки"
                            :min="null"
                            :max="selectedDateEnd"
                            v-model="selectedDateBegin"
                            :rules="[rules.required]"
                        ></DatePicker>
                        <DatePicker
                            outlined
                            dense
                            class="pointer"
                            label="Дата окончания привязки"
                            :min="selectedDateBegin"
                            :max="null"
                            v-model="selectedDateEnd"
                        ></DatePicker>

                        <v-row dense justify="end">
                            <v-btn :disabled="loading" class="rounded-btn px-5" outlined color="primary" @click="cancel">
                                {{ $t('Отменить') }}
                            </v-btn>
                            <v-btn class="rounded-btn px-5 ml-3" :loading="loading" color="info" depressed type="submut">
                                <span>{{ $t('Сохранить') }}</span>
                            </v-btn>
                        </v-row>
                    </v-form>
                </v-container>
            </LabeledCard>
        </v-dialog>
    </v-layout>
</template>

<script>
import FormValidator from '../../mixins/FormValidator';
import LabeledCard from '../ui/LabeledCard';

import DatePicker from '@/components/ui/DatePicker.vue';
import AddressSelector from '@/components/administration/AddressSelector.vue';
import SelectKSKDialog from './SelectKSKDialog.vue';

import KSKService from '@/services/apiRequests/ksk.service';

export default {
    props: {
        isNew: {
            type: Boolean,
            default: false
        },
        details: Object
    },
    mixins: [FormValidator],
    components: { LabeledCard, SelectKSKDialog, AddressSelector, DatePicker },
    data: () => ({
        dialog: false,
        loading: false,
        lazyRules: [], // для того чтобы валидация срабатывала только при попытке отправки формы

        selectedKSK: {},
        selectedHouse: {},
        selectedDateBegin: null,
        selectedDateEnd: null
    }),

    watch: {
        async dialog(opened) {
            if (opened) {
                if (this.isNew) {
                    this.selectedKSK = {};
                    this.selectedHouse = {};
                    this.selectedDateBegin = null;
                    this.selectedDateEnd = null;
                } else {
                    this.selectedKSK = {
                        isas_ksk_rid: this.details.isas_ksk_rid,
                        isas_ksk_name: this.details.isas_ksk_name
                    };

                    this.selectedHouse = {
                        record_id: this.details.isas_address_rid,
                        address_full_name: this.details.isas_address_full_name
                    };

                    this.selectedDateBegin = this.details.date_begin;
                    this.selectedDateEnd = this.details.date_end;
                }

                this.$refs.kskBindingForm.resetValidation();
            }
        }
    },

    methods: {
        async submitForm() {
            this.lazyRules = [this.rules.required];
            if (!this.$refs.kskBindingForm.validate()) return;

            const payload = {
                isas_ksk_rid: this.selectedKSK.isas_ksk_rid,
                isas_address_rid: this.selectedHouse.record_id,
                date_begin: this.selectedDateBegin,
                date_end: this.selectedDateEnd || null
            };

            try {
                this.loading = true;
                if (this.isNew) {
                    await KSKService.addKSKtoHouseBinding(payload);
                    this.$store.dispatch('base/showMessage', {
                        message: this.$t('Новая привязка добавлена')
                    });
                } else {
                    await KSKService.updateKSKtoHouseBinding(this.details.isas_period_rid, payload);
                    this.$store.dispatch('base/showMessage', {
                        message: this.$t('Изменения привязки применены')
                    });
                }
            } finally {
                this.loading = false;
            }

            this.$emit('KSKBindingsUpdated');
            this.dialog = false;
        },

        cancel() {
            this.dialog = false;
        }
    }
};
</script>

<style></style>
